import { HTMLAttributes } from 'react';
import { IIntermediaryFeesDetails } from '../types';

export interface IIntermediaryFeesTable {
  paperProps?: HTMLAttributes<HTMLDivElement>;
  fees: IIntermediaryFeesDetails[];
  onAddFee: () => void;
  onRemoveFee: (index: number) => void;
}

export type TableColumns = 'description' | 'amount' | 'whenPayable' | 'howPayable' | 'refundableAmount';

export const tableColumnsNames: TableColumns[] = [
  'description',
  'amount',
  'whenPayable',
  'howPayable',
  'refundableAmount',
];
